import { BellRingIcon, FileTextIcon, HeartPulseIcon, LinkIcon, ShieldCheckIcon, StethoscopeIcon } from 'lucide-react'

export const healthProfile = {
  name: 'Ahmed Mohammed',
  completion: 65,
  allergies: ['Penicillin'],
  conditions: ['Type 2 diabetes'],
  consentUpdated: '14 Jan 2025',
}

export const insuranceSummary = {
  provider: 'Bupa Arabia',
  memberId: 'BUPA-••••-4821',
  plan: 'Gold',
  expiry: '31 Dec 2025',
  status: 'Verified',
}

export const linkedHealthServices = [
  { title: 'Wasfaty', detail: 'Connected · ready to use', icon: FileTextIcon, tone: 'bg-blue-50 text-blue-700', path: '/prescription?type=wasfaty' },
  { title: 'Insurance profile', detail: 'Bupa Arabia · verified', icon: ShieldCheckIcon, tone: 'bg-emerald-50 text-emerald-700', path: '/prescription?type=insurance' },
  { title: 'Outpatient clinics', detail: 'Upload an external clinic prescription', icon: HeartPulseIcon, tone: 'bg-rose-50 text-rose-700', path: '/prescription?type=outpatient' },
  { title: 'Yusr', detail: 'Submit an eligible Yusr prescription', icon: LinkIcon, tone: 'bg-violet-50 text-violet-700', path: '/prescription?type=yusr' },
]

export const healthActions = [
  { title: 'Manage prescriptions', detail: 'Track approvals and deliveries', icon: FileTextIcon, path: '/prescription/history' },
  { title: 'Medicine reminders', detail: 'Stay on schedule with daily doses', icon: BellRingIcon, path: '/medicine-reminder' },
  { title: 'Ask a pharmacist', detail: 'Medication support when you need it', icon: StethoscopeIcon, path: '/pharmacist-consultation' },
]
